import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const userEntity: Entity = {
  model: model,
  repository: repository,
}

export default userEntity
